(function () {
    'use strict';
    angular
        .module('app')
        .controller('browseFolderBox', browseFolderBox);
    browseFolderBox.$inject = ['$rootScope', '$scope', '$mdDialog', 'loginService', 'zcs', 'folderBrowserService', '$q'];
    function browseFolderBox($rootScope, scope, $mdDialog, loginService, zcs, folderBrowserService, $q) {
        scope.loginService = loginService;

        // Initialized in browseFolderBoxShow.
        scope.browseFolderBox = $rootScope.browseFolderBox;

        scope.xyz = {};
        scope.xyz.browseForFolderDialogId = "";
        scope.xyz.processing = false;
        scope.xyz.bAbortBrowse = false;

        scope.OnFolderChange = function () {
            $rootScope.browseFolderBox.folderError = false;
            $rootScope.browseFolderBox.folderOK = false;
            if (scope.browseFolderBox.edit1 != '') {
                folderBrowserService.verifyDirectory(scope.browseFolderBox.edit1).then(function (data) {
                    if (data == true) {
                        $rootScope.browseFolderBox.folderError = false;
                        $rootScope.browseFolderBox.folderOK = true;
                    }
                    else {
                        $rootScope.browseFolderBox.folderOK = false;
                        $rootScope.browseFolderBox.folderError = true;
                        $rootScope.browseFolderBox.folderErrorText = loginService.resourceStrings["WORK_AREA_INVALID_DIRECTORY"]; //'Invalid directory or you do not have permission to access this directory';
                    }
                }, function () {
                    deferred.reject(obj);
                });
            }
        }

        scope.sendEvents = function (bOK, uncPath) {
            // If there is a PRE event.
            if (scope.browseFolderBox.preClosePromiseCallback != null) {
                // Fire the PRE event.
                scope.browseFolderBox.preClosePromiseCallback($rootScope.browseFolderBox.param1, $rootScope.browseFolderBox.param2, bOK,
                    uncPath, $rootScope.browseFolderBox.driveType, $rootScope.browseFolderBox.edit2).then(function (data) {
                        // Close the dialog.
                        $mdDialog.hide();
                        // Fire the POST event.
                        if (scope.browseFolderBox.postCloseCallback != null) {
                            scope.browseFolderBox.postCloseCallback($rootScope.browseFolderBox.param1, $rootScope.browseFolderBox.param2, bOK,
                                uncPath, $rootScope.browseFolderBox.driveType, $rootScope.browseFolderBox.edit2);
                        }
                    }, function (response) {
                        // no-op. Keep the dialog open.
                    });
            }
            else {
                // Close the dialog.
                $mdDialog.hide();
                // Fire the POST event.
                if (scope.browseFolderBox.postCloseCallback != null) {
                    scope.browseFolderBox.postCloseCallback($rootScope.browseFolderBox.param1, $rootScope.browseFolderBox.param2, bOK,
                        $rootScope.browseFolderBox.edit1, $rootScope.browseFolderBox.driveType, $rootScope.browseFolderBox.edit2);
                }
            }
        }

        // Not critical if this is not set in time for the first click of the browse button.
        zcs.GetMyDocsFolder().then(function (myDocsFolder) {
            scope.myDocsFolder = myDocsFolder;
        });

        var getInitialPath = function () {
            var initialPath = scope.browseFolderBox.edit1;
            if (initialPath == null || initialPath.length < 1)
                initialPath = $rootScope.browseFolderBox.initialPath;
            if (initialPath == null || initialPath.length < 1) {
                initialPath = scope.myDocsFolder;
            }
            return initialPath;
        }

        scope.isWindowsExplorerEnabled = function () {
            var initialPath = getInitialPath();
            if (initialPath && initialPath.length > 0)
                return true;
            return false;
        }

        scope.onBrowseButtonClicked = function () {
            scope.xyz.processing = true;
            var initialPath = getInitialPath();

            zcs.GetLocalPath(initialPath).then(function (response) {
                initialPath = response;
                folderBrowserService.show(initialPath).then(function (path) {
                    // The call returns null on cancel.
                    if (path == null) {
                        scope.xyz.processing = false;
                        return;
                    }
                    scope.browseFolderBox.edit1 = path; // UNC Path;
                    //scope.browseFolderBox.driveType = driveType;
                    scope.xyz.processing = false;
                    scope.OnFolderChange();
                }, function () {
                    console.log("Cancelled.");
                    scope.xyz.processing = false;
                })
            });
        }

        scope.onWindowsExplorerClicked = function () {
            var initialPath = getInitialPath();
            zcs.WindowsExplorer(initialPath).then(function () {

            }, function (err) {
                //handled by http - $rootScope.msgBoxShow(err.data.ExceptionMessage, loginService.resourceStrings["SHOW_IN_WINDOWS_EXPLORER"]);
            });
        }

        scope.onBrowseFolderBoxOK = function () {
            //scope.abortBrowseIfNecessary();
            zcs.GetUNC(scope.browseFolderBox.edit1).then(function (response) {
                var uncPath = response;

                var DriveType_Local = "L";
                var DriveType_Network = "N";
                var dollarPos = response.indexOf("$\\");
                if (dollarPos < 0)
                    scope.browseFolderBox.driveType = DriveType_Network;
                else
                    scope.browseFolderBox.driveType = DriveType_Local;

                if (scope.browseFolderBox.edit2 == null)
                    scope.browseFolderBox.edit2 = "";

                zcs.CreateDirectory(scope.browseFolderBox.edit1).then(function (response) {
                    var errMsg = response;
                    // Handle Error
                    if (errMsg != null && errMsg.length > 0) {
                        $rootScope.msgBoxShow(errMsg, loginService.resourceStrings["ACCESS_FOLDER_FAILED"]); // CREATE_FOLDER_FAILED
                        if (scope.browseFolderBox.continueOnAccessFailure)
                            scope.sendEvents(true, uncPath);
                    }
                    else { // No error.
                        scope.sendEvents(true, uncPath);
                    }
                }, function (err) {
                    // Call only returns errStr, no exceptions.
                    ////handled by http - $rootScope.msgBoxShow(err.data.ExceptionMessage, loginService.resourceStrings["CREATE_FOLDER_FAILED"]);
                    //if (scope.browseFolderBox.continueOnAccessFailure)
                    //    scope.sendEvents(true);
                });
            });
        }

        scope.onBrowseFolderBoxCancel = function () {
            if (scope.browseFolderBox.edit1.length === 0) {
                scope.sendEvents(false, scope.browseFolderBox.edit1);
            } else {
                //scope.abortBrowseIfNecessary();
                zcs.GetUNC(scope.browseFolderBox.edit1).then(function (resp) {
                    scope.sendEvents(false, resp);
                });
            }
        }

        function activate() {
            scope.OnFolderChange();
        }
        activate();
    }
})();
